import { toast } from 'react-toastify';

const showToast = (message="", type="i") => {
  switch (type) {
    case 's': 
      toast.success(message,{position: "top-center"});
      break;
    case 'e':
      toast.error(message,{position: "top-center"});
      break;
    case 'w': 
      toast.warn(message,{position: "top-center"});
      break;
    case 'i': 
      toast.info(message,{position: "top-center"});
      break;
    default:
      toast.info(message,{position: "top-center"});
      break;
  }
};

export default showToast;
